module.exports = __webpack_public_path__ + "img/Cisco-ASA.e3f495b.svg";